const DISMISSED_STORAGE_KEY = 'newsletter-popup-dismissed-at';
const SUBSCRIBED_STORAGE_KEY = 'newsletter-subscribed-at';
const DAY_IN_MS = 86400000;
const BUSY_RETRY_MS = 5000;

function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {}
}

class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.input = this.querySelector('input[type="email"]');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.updatePlaceholder();
    this.mobileQuery.addEventListener('change', this.updatePlaceholder);

    this.dialog.addEventListener('click', this.handleDialogClick);
    this.dialog.addEventListener('close', this.handleClose);
    this.addEventListener('newsletter:subscribe', this.handleSubscribe);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', this.handleEditorSelect);
      document.addEventListener('shopify:section:load', this.handleEditorSelect);
      document.addEventListener('shopify:section:deselect', this.handleEditorDeselect);
      return;
    }

    if (!this.shouldOpen()) return;

    this.openTimer = window.setTimeout(this.open, Number(this.dataset.delay || 0) * 1000);

    if (this.hasAttribute('data-exit-intent') && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', this.handleExitIntent);
    }
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
    this.mobileQuery?.removeEventListener('change', this.updatePlaceholder);
    document.removeEventListener('mouseout', this.handleExitIntent);
    document.removeEventListener('shopify:section:select', this.handleEditorSelect);
    document.removeEventListener('shopify:section:load', this.handleEditorSelect);
    document.removeEventListener('shopify:section:deselect', this.handleEditorDeselect);
  }

  shouldOpen() {
    if (this.hasAttribute('data-hide-from-email-visitors') && this.isFromKlaviyoEmail()) {
      writeStorage(SUBSCRIBED_STORAGE_KEY, String(Date.now()));
      return false;
    }

    if (readStorage(SUBSCRIBED_STORAGE_KEY)) return false;

    const dismissedAt = Number(readStorage(DISMISSED_STORAGE_KEY));
    const waitMs = Number(this.dataset.dismissDays || 0) * DAY_IN_MS;
    return !dismissedAt || Date.now() - dismissedAt >= waitMs;
  }

  isFromKlaviyoEmail() {
    const params = new URLSearchParams(window.location.search);
    return params.has('_kx') || /klaviyo/i.test(params.get('utm_source') || '');
  }

  open = () => {
    window.clearTimeout(this.openTimer);
    document.removeEventListener('mouseout', this.handleExitIntent);
    if (this.dialog.open) return;

    if (document.querySelector('dialog[open]')) {
      this.openTimer = window.setTimeout(this.open, BUSY_RETRY_MS);
      return;
    }

    this.dialog.showModal();
  };

  handleExitIntent = (event) => {
    if (!event.relatedTarget && event.clientY <= 0) this.open();
  };

  handleDialogClick = (event) => {
    if (event.target === this.dialog || event.target.closest('[data-newsletter-popup-close]')) {
      this.dialog.close();
    }
  };

  handleClose = () => {
    if (window.Shopify?.designMode || this.subscribed) return;
    writeStorage(DISMISSED_STORAGE_KEY, String(Date.now()));
  };

  handleSubscribe = () => {
    this.subscribed = true;
    this.dialog.dataset.state = 'subscribed';
  };

  handleEditorSelect = (event) => {
    if (event.detail?.sectionId === this.dataset.sectionId) this.open();
  };

  handleEditorDeselect = (event) => {
    if (event.detail?.sectionId === this.dataset.sectionId) this.dialog.close();
  };

  updatePlaceholder = () => {
    if (!this.input) return;

    const { placeholderDesktop, placeholderMobile } = this.input.dataset;
    this.input.placeholder = (this.mobileQuery.matches && placeholderMobile) || placeholderDesktop || '';
  };
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup);
}
